"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CANADA_PROVINCES = exports.DEFAULT_COUNTRIES = exports.COUNTRY_CANADA_ID = exports.COUNTRY_USA_ID = void 0;
var COUNTRY_USA_ID = 1;
exports.COUNTRY_USA_ID = COUNTRY_USA_ID;
var COUNTRY_CANADA_ID = 2;
exports.COUNTRY_CANADA_ID = COUNTRY_CANADA_ID;
var DEFAULT_COUNTRIES = {
  US: {
    id: COUNTRY_USA_ID,
    name: 'United States',
    code: 'US'
  },
  CA: {
    id: COUNTRY_CANADA_ID,
    name: 'Canada',
    code: 'CA'
  }
};
exports.DEFAULT_COUNTRIES = DEFAULT_COUNTRIES;
var CANADA_PROVINCES = [{
  name: 'Alberta',
  abbr: 'AB'
}, {
  name: 'British Columbia',
  abbr: 'BC'
}, {
  name: 'Manitoba',
  abbr: 'MB'
}, {
  name: 'New Brunswick',
  abbr: 'NB'
}, {
  name: 'Newfoundland and Labrador',
  abbr: 'NL'
}, {
  name: 'Northwest Territories',
  abbr: 'NT'
}, {
  name: 'Nova Scotia',
  abbr: 'NS'
}, {
  name: 'Nunavut',
  abbr: 'NU'
}, {
  name: 'Ontario',
  abbr: 'ON'
}, {
  name: 'Prince Edward Island',
  abbr: 'PE'
}, {
  name: 'Quebec',
  abbr: 'QC'
}, {
  name: 'Saskatchewan',
  abbr: 'SK'
}, {
  name: 'Yukon Territory',
  abbr: 'YT'
}];
exports.CANADA_PROVINCES = CANADA_PROVINCES;